import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';

import IconBase from './icon-base';

const IconMinus = ({ fill, width, height, hoverColor, className }) => (
  <IconBase
    className={className}
    viewBox="0 0 448 512"
    width={width}
    height={height}
    fill={fill}
    hoverColor={hoverColor}
  >
    <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
  </IconBase>
);

export default IconMinus;
